import {
  SET_LISTEN_RECORD_MODAL_VISIBLE,
  SET_CURRENT_RECORD_URL,
  CLEAR_CURRENT_RECORD_URL,
  SET_CURRENT_CALL_INFO,
  CLEAR_CURRENT_CALL_INFO,
} from './callHistoryActionTypes';

const initialState = {
  listenRecordModalVisible: false,
  currentRecordUrl: '',
  currentCallInfo: null,
};

const callHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LISTEN_RECORD_MODAL_VISIBLE:
      return {
        ...state,
        listenRecordModalVisible: payload,
      };
    case SET_CURRENT_RECORD_URL:
      return {
        ...state,
        currentRecordUrl: payload,
      };
    case CLEAR_CURRENT_RECORD_URL:
      return {
        ...state,
        currentRecordUrl: '',
      };
    case SET_CURRENT_CALL_INFO:
      return {
        ...state,
        currentCallInfo: payload,
      };
    case CLEAR_CURRENT_CALL_INFO:
      return {
        ...state,
        currentCallInfo: null,
      };
    default:
      return state;
  }
};

export default callHistoryReducer;
